import JobAddEdit from "./JobAddEdit";
const JobCreate = () => {
  return <div className="overflow-y w-full ">
    <JobAddEdit />
  </div>;
};
export default JobCreate;
